<template>
  <div class="legal-page">
    <div class="container">
      <div class="card">
        <h1 class="card-header">{{ $t('legal.privacyTitle') }}</h1>
        <div class="card-content" v-html="content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import privacy from './privacy.content.js'

export default {
  name: 'privacy',
  computed: {
    ...mapGetters(['language']),
    content () {
      return privacy[this.language] || privacy['zh-tw']
    }
  }
}
</script>

<style lang="scss">
@import '../../styles/views/Legal.scss';
</style>
